import React, { useEffect, useRef } from 'react';
import VendorAccessModal from '../components/VendorAccessModal/VendorAccessModal';
import styles from './VendorAccess.module.css';
import { AppDispatch, IRootState } from '../redux/rootReducer';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../components/common/loader/Loader';
import { useParams } from 'react-router-dom';
import { getLocationById, getLocationPublicDetailsById } from '../redux/location/actions/location.action';
import { clearVendorAppointmentsState } from '../redux/vendorAppointments/actions/vendorAppointments.action';

const VendorAccess = () => {

  const dispatch: AppDispatch = useDispatch();
  const hasCalledAPI = useRef(false);
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    if (id && !hasCalledAPI.current) {
      hasCalledAPI.current = true;
      dispatch(getLocationPublicDetailsById(id));
    }
    return () => {
      dispatch(clearVendorAppointmentsState());
    }
  }, [id, dispatch]);

  const { data: locationData, loading: locationLoading } = useSelector((state: IRootState) => state.locationReducer.locationPublicDetails);

  return (
    <div
      className={`${styles.container}  ${locationData && locationData?.data && locationData?.data?.images?.length ? styles.propertyImageWrapper : ''}`}
      style={
        locationData?.data?.images?.[0]
          ? {
            backgroundImage: `url(${locationData?.data?.images[0]})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundAttachment: "fixed",
            width: "100%",
          }
          : {}
      }
    >
      {locationLoading ? <Loader /> : <VendorAccessModal />}
    </div>
  );
};

export default VendorAccess;